import { useQuery } from 'react-query'
import request from '../request'
import { useDealership } from '../../store/zustand/dealershipStore'
import { useBuildQueryParams } from '../../lib/hooks/useBuildQueryParams'

type ResultType = {
  unitsSold: number
  attributedSales: number
  attributedRevenue: number
  daysToConvert: number
}
export const useGetPerformanceStats = ({
  filters,
}: {
  filters?: Record<string, unknown>
}) => {
  const dealership = useDealership()
  const queryParams = useBuildQueryParams(filters)

  return useQuery<ResultType, Error>(
    ['dealership', dealership?.id, 'performance', 'stats', { queryParams }],
    () =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/stats/performance`,
        method: 'GET',
        params: {
          ...queryParams,
        },
      }).then((res: any) => res.data),
    {
      enabled: !!dealership,
    },
  )
}
